<script>
  import { createEventDispatcher } from 'svelte';
  import Button from '@components/Button.svelte';
  import Modal from '@components/Modal.svelte';

  const dispatch = createEventDispatcher();

  export let header = '';
  export let message = '';
  export let buttonText;
  export let headerImageSrcSet = '/images/app-invites/smiling-face.png 1x, /images/app-invites/smiling-face@2x.png 2x';

  export let mobile = false;
  export let show = false;
  export let showCloseButton = true;
</script>

<style style="text/scss" lang="scss">
  * :global(.modal__container) {
    background-image: url(/images/thank-you-background.png);
    background-size: cover;
    max-width: 640px;
  }

  .thank-you-container {
    padding-top: 60px;
    padding-bottom: 60px;
    display: flex;
    flex-direction: column;

    .ty-image {
      text-align: center;
    }

    .ty-header {
      margin-top: 26px;
      font-size: 32px;
      line-height: 40px;
      font-weight: bold;
      text-align: center;
    }

    .ty-message {
      font-size: 14px;
      line-height: 21px;
      text-align: center;
      color: #7f7f7f;
      margin-top: 20px;
      max-width: 370px;
      margin-left: auto;
      margin-right: auto;
    }

    .ty-button {
      margin-top: 40px;
      text-align: center;
    }
  }
</style>

<div class="svelte-modal">
  <Modal
    mobile={mobile}
    on:close={() => {
      show = false;
      dispatch('close');
    }}
    bind:show={show}
    showCloseButton={showCloseButton}
    fadeInDuration={200}>
    <div slot="content" class:mobile={mobile}>
      <div class="thank-you-container">
        <div class="ty-image"><img alt="smiling-face" srcset={headerImageSrcSet} /></div>
        <div class="ty-header">{header}</div>
        <div class="ty-message">{message}</div>
        <div class="ty-button">
          <Button
            style="width: unset; padding-left: 20px; padding-right: 20px;"
            on:click={() => {
              dispatch('finished');
            }}
            text={buttonText} />
        </div>
      </div>
    </div>
  </Modal>
</div>
